var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "section-inn content walletHist",
      attrs: { id: _setup.props.id },
    },
    [
      _c("div", { staticClass: "cashbox-filter" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c("div", { staticClass: "cashbox-filter__inner" }, [
              _c(
                "div",
                { staticClass: "cashbox-filter__line" },
                [
                  _vm._v("\n        Период\n\n        "),
                  _c(_setup.Dpick, {
                    attrs: { placeholder: "с", value: _setup.vals.beg },
                    on: {
                      change: function ($event) {
                        return _setup.set_val("beg", $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(_setup.Dpick, {
                    attrs: { placeholder: "до", value: _setup.vals.end },
                    on: {
                      change: function ($event) {
                        return _setup.set_val("end", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cashbox-filter__line" },
                [
                  _vm._v("\n        Номер заявки \n        "),
                  _c(_setup.Nomerpick, {
                    attrs: { placeholder: "9999999" },
                    model: {
                      value: _setup.nomer,
                      callback: function ($$v) {
                        _setup.nomer = $$v
                      },
                      expression: "nomer",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _setup.isError
                ? _c(
                    "div",
                    {
                      staticClass: "cashbox-filter__line",
                      staticStyle: { padding: "10px", background: "#ffaaaa" },
                    },
                    [_vm._v("Данные не получены!")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "cashbox-filter__line" }, [
                _c(
                  "button",
                  {
                    staticClass: "cashbox-filter__btn",
                    on: { click: _setup.reset },
                  },
                  [_vm._v("сбросить фильтр")]
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "a",
                  { attrs: { target: "_blank", href: _setup.excel_link } },
                  [_vm._v("Экспорт в EXCEL")]
                ),
              ]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "cashbox-table" }, [
        _c("thead", [
          _c("tr", [
            _c(
              "th",
              [
                _setup.wait
                  ? [
                      _setup.wait
                        ? _c(_setup.Dots, { staticClass: "cashbox__dots" })
                        : _vm._e(),
                    ]
                  : [_vm._v("\n            дата\n          ")],
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "th",
              [
                _setup.wait
                  ? [
                      _setup.wait
                        ? _c(_setup.Dots, { staticClass: "cashbox__dots" })
                        : _vm._e(),
                    ]
                  : [_vm._v("\n            детали\n          ")],
              ],
              2
            ),
            _vm._v(" "),
            _c("th", [_vm._v("приход")]),
            _vm._v(" "),
            _c("th", [_vm._v("расход")]),
            _vm._v(" "),
            _c("th", [_vm._v("баланс")]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_setup.operations, function (op) {
            return _c("tr", [
              _c("td", [_vm._v(_vm._s(_setup.dmy(op.date)))]),
              _vm._v(" "),
              _c("td", [
                _vm._v("\n          " + _vm._s(op.detail) + "\n          "),
                op.claim_id
                  ? _c("a", { attrs: { href: _setup.claim_link(op) } }, [
                      _vm._v(_vm._s(op.claim_num)),
                    ])
                  : _vm._e(),
                _vm._v("\n          " + _vm._s(op.corp_str) + " \n        "),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_setup.price3rub(op.income)))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_setup.price3rub(op.expend)))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_setup.price3rub(op.balance)))]),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cashbox-pagination" }, [
        _c(
          "button",
          {
            staticClass: "cashbox-pagination__btn",
            attrs: { disabled: _setup.page_next_disabled },
            on: { click: _setup.page_next },
          },
          [_vm._v("показать еще")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "cashbox-pagination__btn",
            attrs: { disabled: _setup.page_all_disabled },
            on: { click: _setup.page_all },
          },
          [_vm._v("показать все")]
        ),
        _vm._v(" "),
        _setup.wait ? _c("span", { staticClass: "loadi" }) : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }